// MyLinkModule.js

export default class MyLinkModule {
    constructor(quill, options) {
      this.quill = quill;
      this.options = options;
      this.quill.on('text-change', this.handleTextChange.bind(this));
      // this.quill.root.addEventListener('blur', this.handleBlur.bind(this));
    }
  
    handleTextChange(delta, oldDelta, source) {
      if (source === 'user') {
        const text = this.quill.getText();
        const urlPattern = /(\bhttps?:\/\/[^\s]+|\bwww\.[^\s]+)/gi;
        const matches = text.match(urlPattern);
  
        if (matches) {
          matches.forEach((url) => {
            const index = text.indexOf(url);
            const length = url.length;
  
            // Check if there is a space after the URL
            if (text[index + length] === ' ') {
              const href = url.startsWith('http') ? url : `http://${url}`;
  
              // Check if the link is already applied to avoid redundant links
              const [leaf] = this.quill.getLeaf(index);
              if (leaf.parent.domNode.tagName !== 'A') {
                this.quill.formatText(index, length, 'link', href);
              }
            }
          });
        }
      }
    }
  
    handleBlur() {
      const text = this.quill.getText();
      const urlPattern = /(\bhttps?:\/\/[^\s]+|\bwww\.[^\s]+)/gi;
      const matches = text.match(urlPattern);
  
      if (matches) {
        matches.forEach((url) => {
          const index = text.indexOf(url);
          const length = url.length;
          const href = url.startsWith('http') ? url : `http://${url}`;
  
          // Check if the link is already applied to avoid redundant links
          const [leaf] = this.quill.getLeaf(index);
          if (leaf.parent.domNode.tagName !== 'A') {
            this.quill.formatText(index, length, 'link', href);
          }
        });
      }
    }
  }
  